import React from 'react';
import Modal from '../common/Modal';
import Loader from '../common/Loader';
import Button from '../common/Button';
import APIServicesRegistry from '../../api-services/APIServicesRegistry';
import ProjectAPIService from '../../api-services/ProjectApiService';
import ProjectCollaborationCardEditableListSection from './ProjectCollaborationCardEditableListSection';

export default class ProjectSendQuoteModal extends React.Component {

    state = {
        busy: true,
        selectedViewers: [],
        projectCreator: null,
        rfqCreator: null,
        members: null,
        selectedProjectCreator: false,
        selectedRfqCreator: false,
        othersEditable: false
    }

    constructor(props) {
        super(props);
        this.setState({busy: true});
        APIServicesRegistry.getService(ProjectAPIService).getSendQuoteData(this.props.id)
            .then(response => {
                this.setState({
                    ...response.data,
                    busy: false
                })
            })
    }

    onYesClick = () => {
        const service = APIServicesRegistry.getService(ProjectAPIService);

        let viewers = this.state.selectedViewers.map(x => x.value);

        if (this.state.selectedProjectCreator) {
            viewers.push(this.state.projectCreator.id);
        }

        if (this.state.selectedRfqCreator) {
            viewers.push(this.state.rfqCreator.id);
        }

        service.sendQuote({
            projectId: this.props.id,
            viewers
        }).then(() => {
            this.setState({busy: false});
            this.props.onClose();
        }).catch(() => {
            this.setState({busy: false});
        });
    }

    onNoClick = () => {
        this.props.onClose();
    }

    createCreator = (label, creator, onChange) => (
        <div className="project-collaboration-field">
            <div className="project-collaboration-field-label">
                {__(label)}
            </div>
            <div className="project-collaboration-field-value">
                <input type="checkbox" id={creator.id} onChange={(e) => onChange(e)}></input>
                <label htmlFor={creator.id}>{creator.name}</label>
            </div>
        </div>
    )

    handleToggleEditable = (value) => {
        if (!value) {

        }
    }

    render() {
        return (
            <Modal class="send-quote-modal" overflow="inherit" isOpen={this.props.visible} onClose={this.props.onClose}>
                <Modal.Header>{__('Send quote')}</Modal.Header>
                <Modal.Body>
                    <div className="send-quote-modal-body">
                        {this.state.busy && <Loader fillContainer={true}/>}
                        {!this.state.busy &&
                            (
                                <React.Fragment>
                                    {this.state.projectCreator &&
                                        this.createCreator('Project creator', this.state.projectCreator, (e) => this.setState({selectedProjectCreator: e.target.checked}))
                                    }
                                    {this.state.rfqCreator &&
                                        this.createCreator('Rfq creator', this.state.rfqCreator, (e) => this.setState({selectedRfqCreator: e.target.checked}))
                                    }
                                    <div className="others">
                                        <ProjectCollaborationCardEditableListSection
                                            title={__('Others')}
                                            editable={true}
                                            value={this.state.selectedViewers}
                                            autocompleteSuggestions={this.state.members}
                                            onParticipantAddClick={this.addViewer}
                                            onParticipantRemoveClick={this.removeViewer}
                                            handleToggleEditable={(value) => this.setState({othersEditable: value})}
                                        />
                                    </div>
                                </React.Fragment>
                            )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button theme={Button.Theme.BorderOnly} onClick={this.onNoClick}>{__('No')}</Button>
                    <Button theme={Button.Theme.BorderOnly} onClick={this.onYesClick}>{__('Yes')}</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    addViewer = viewer => {
        var items = this.state.selectedViewers;
        items.push(viewer);
        this.setState({
            selectedViewers: items
        });
    }

    removeViewer = viewer => {
        var items = this.state.selectedViewers.filter(x => x.value != viewer.value);
        this.setState({
            selectedViewers: items
        });
    }
}